import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';
import { Tabs } from 'antd';
import { DollarSign } from 'lucide-react';
import { ConfigurationBilling } from './Billing';
import { ConfigurationExpenses } from './Expenses';

export const Route = createFileRoute('/console/$orgId/configuration/financials/expenses-billing')({
    staticData: {
        metadata: {
            title: 'Expenses and billing',
        },
        ui: {
            icon: DollarSign,
            title: 'Expenses and billing configuration',
            subtitle: 'Manage expense categories and billing',
            menuDescription: 'Manage expense categories and billing',
        },
        modules: ['billing'],
        permissions: ['settings:update'],
    },
    component: ConfigurationExpensesAndBilling,
});

function ConfigurationExpensesAndBilling() {
    return (
        <PageController route={Route}>
            <Tabs
                type="line"
                items={[
                    {
                        key: 'expenses',
                        label: 'Expenses',
                        children: <ConfigurationExpenses />,
                    },
                    {
                        key: 'billing',
                        label: 'Billing offices',
                        children: <ConfigurationBilling />,
                    },
                ]}
            />
        </PageController>
    );
}
